import React from 'react';
import { LoginBackButton, LoginTextLink } from './LoginControls';

/**
 * Login v2 — after "Forgot password?". The heading and the "We sent a reset
 * link to …" line come from the card; this is what the person can do next.
 * The screen reads the same whether or not the address has an account.
 */

interface CheckInboxStepProps {
  /** A resend is in flight. */
  sending: boolean;
  /** Seconds left before another link may be requested; 0 = available. */
  resendCooldown: number;
  /** Confirmation after a successful resend. */
  notice: string;
  onResend: () => void;
  onBack: () => void;
}

export const CheckInboxStep: React.FC<CheckInboxStepProps> = ({
  sending,
  resendCooldown,
  notice,
  onResend,
  onBack,
}) => (
  <div className="flex flex-col">
    {notice && (
      <p role="status" className="mb-s3 text-body-sm text-success-ink">
        {notice}
      </p>
    )}
    <p className="mb-[16px] text-body-sm text-ink-secondary">
      Didn&apos;t get it?{' '}
      <LoginTextLink onClick={onResend} disabled={sending || resendCooldown > 0}>
        {sending ? 'Sending…' : resendCooldown > 0 ? `Resend in ${resendCooldown}s` : 'Resend'}
      </LoginTextLink>
    </p>
    <LoginBackButton onClick={onBack} label="Back to sign in" last />
  </div>
);

export default CheckInboxStep;
